export default [
  {
    path: "/audit-dashboard",
    name: "audit-main",
    component: () =>
      import("../../modules/Audit/pages/AuditDashboard/UI/AuditDashboard.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["audit"],
    },
  },
  {
    path: "/audit-mentors",
    name: "audit-mentors",
    component: () =>
      import("../../modules/Audit/pages/AuditMentors/UI/AuditMentors.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["audit"],
    },
  },
  {
    path: "/audit-warnings",
    name: "audit-warnings",
    component: () =>
      import("../../modules/Audit/pages/AuditWarnings/UI/AuditWarnings.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["audit"],
    },
  },
];
